import { forwardRef } from "react";
import { Button as AntButton } from "antd";
import classNames from "classnames";

const Button = forwardRef((props, ref) => {
  const { iconRight, className, ...rest } = props;
  return <AntButton ref={ref} className={classNames(className, { "icon-right": iconRight })} {...rest} />;
});

Button.displayName = "Button";

export default Button;
